import {FullscreenOverlayWithSpinner} from '@yandex-delivery/blocks'
import {OrderMap} from '@yandex-delivery/order-form/src/components/order-map/index@desktop'
import type {FC} from 'react'

import {ActionProvider, StatusProvider} from '../../contexts'
import {renderWidget} from '../../widgets/index@desktop'
import {LayoutSkeleton} from '../LayoutSkeleton/index@desktop'
import * as classes from './Form@desktop.classes'
import {useOrderForm} from './hooks/use-order-form'

export const Form: FC = () => {
  const {layout, isFetching, isLoading, onSubmit, isOverlayVisible} = useOrderForm()

  if (!isLoading && !layout) {
    throw new Error('Root form widget is not found')
  }

  return (
    <StatusProvider isFetching={isFetching}>
      <ActionProvider onSubmit={onSubmit}>
        {isOverlayVisible && <FullscreenOverlayWithSpinner />}
        {layout ? renderWidget(layout, 'layout') : <LayoutSkeleton />}
        <div className={classes.map}>
          <OrderMap />
        </div>
      </ActionProvider>
    </StatusProvider>
  )
}
